module.exports = "pegasus_template/assets/square-facebook.png";